
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","enable-background":"new 0 0 40 40","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#FF0062"}}),_c('circle',{attrs:{"cx":"32","cy":"8","r":"8","fill":"#00C900"}}),_c('circle',{attrs:{"cx":"8","cy":"32","r":"8","fill":"#0081FD"}}),_c('circle',{attrs:{"cx":"32","cy":"32","r":"8","fill":"#9D47FF"}})])
          )
        }
      }
    